import { render, staticRenderFns } from "./game-category-list.vue?vue&type=template&id=f90cf9cc&scoped=true"
import script from "./game-category-list.vue?vue&type=script&lang=js"
export * from "./game-category-list.vue?vue&type=script&lang=js"
import style0 from "./game-category-list.vue?vue&type=style&index=0&id=f90cf9cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90cf9cc",
  null
  
)

export default component.exports